// extracted by mini-css-extract-plugin
export default {"pricing":"Pricing_pricing__rjhta"};